import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatNOK } from "@/lib/format";
import type { PipelineEntry } from "@/lib/dashboard-panels-calc";

interface PipelinePanelProps {
  teamTotal: number;
  perPerson: PipelineEntry[];
  nameOf: (userId: string) => string;
  isLoading?: boolean;
}

/**
 * F2.4 Pipeline BF — expected BF for accepted-but-not-completed projects.
 * Total (reacts to person filter) + per-person breakdown. Live snapshot, not
 * period-bound (matches pipelineBf semantics).
 */
export function PipelinePanel({ teamTotal, perPerson, nameOf, isLoading }: PipelinePanelProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">GEEK-pipeline</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {isLoading ? (
          <div className="h-28 animate-pulse rounded bg-muted" />
        ) : (
          <>
            <div className="flex items-baseline justify-between border-b pb-2">
              <span className="text-sm text-muted-foreground">Total</span>
              <span className="text-lg font-semibold tabular-nums">{formatNOK(teamTotal)}</span>
            </div>
            {perPerson.length === 0 ? (
              <p className="text-sm text-muted-foreground">Ingen aktiv pipeline.</p>
            ) : (
              <ul className="space-y-1">
                {perPerson.map((p) => (
                  <li key={p.userId} className="flex items-center justify-between text-sm">
                    <span className="font-medium">{nameOf(p.userId)}</span>
                    <span className="tabular-nums">{formatNOK(p.pipelineKr)}</span>
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
